import { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import Navbar from "../containers/Navbar/Navbar";
import Footer from "../containers/Footer/Footer";
import { WavyDivider } from "../styles/HomeStyles";
import ScrollToTop from "../containers/ScrollToTop/ScrollToTop";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
  backgroundColor: "#ffffff",
  // backgroundImage:
  //   "radial-gradient(#00adf8 0.5px, transparent 0.5px), radial-gradient(#00adf8 0.5px, #ffffff 0.5px)",
  // backgroundSize: "20px 20px",
  // backgroundPosition: " 0 0,10px 10px",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 20,
  // paddingBottom: theme.spacing(5),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 10,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function HomeLayout() {
  return (
    <RootStyle id="home">
      {/* <Navbar  onOpenSidebar={() => setOpen(true)}  /> */}
      <MainStyle>
        <Outlet />
        <ScrollToTop />
        <Footer />
      </MainStyle>
    </RootStyle>
  );
}
